import { Group, Skeleton, Stack, Text, useMantineTheme } from '@mantine/core';
import { IconSparkles } from '@tabler/icons-react';
import { AiSummaryBasePanel } from 'app/Private/Clients/Detail/InfoTab/components/AiSummaryPanel/AiSummaryBasePanel';
import { i18nKeys } from 'locales/index';
import { useTranslation } from 'locales/logic';
import { animatedGradientText } from './AiSummaryPanel.styles';

export const AiSummaryLoadingPanel = () => {
  const { t } = useTranslation();
  const theme = useMantineTheme();

  return (
    <AiSummaryBasePanel
      title={
        <Group gap={6}>
          <IconSparkles color={theme.colors.purple[6]} size={18} stroke={1.5} />
          <Text className={animatedGradientText}>{t(i18nKeys.AI_SUMMARY.BILLING_PANEL.TITLE)}</Text>
        </Group>
      }
    >
      <Stack>
        <Skeleton h={16} w="100%" />
        <Skeleton h={16} w="100%" />
        <Skeleton h={16} w="80%" />
      </Stack>
    </AiSummaryBasePanel>
  );
};
